import { selectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { fileConfig } from '@adornis/file-utils/config.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';
import { getAdornisFileByID } from '../api/files.js';

/** Server-only: return the checked path so callers attach exactly the path that was validated. */
export async function assertInsideFileStore(file: {
  _id: string;
  _class: string;
  getFullPath(): string;
}): Promise<string> {
  const { resolve, sep } = await import('node:path');
  if (!/^[A-Za-z0-9_-]+$/.test(file._id)) throw new Error('Refusing to attach file outside the file store');
  const fullPath = resolve(file.getFullPath());
  const storeDirectory = resolve(fileConfig.get('datadir'), file._class);
  if (!fullPath.startsWith(storeDirectory + sep)) throw new Error('Refusing to attach file outside the file store');
  return fullPath;
}

export async function fileAttachment(fileID: string, filename: string): Promise<{ filename: string; path: string }> {
  const file = await getAdornisFileByID(fileID)(selectionSet(() => AdornisFile, 2));
  if (!file) throw new Error(`Cannot attach file: no AdornisFile found for ID ${fileID}`);
  return { filename, path: await assertInsideFileStore(file) };
}
